export default {
  title: {
    interviewMeetingRoomManagement: 'Interview Meeting Room Management',
    addInterviewMeetingRoom: 'Add',
    editInterviewMeetingRoom: 'Edit'
  },
  menu: 'Interview Meeting Room Management',
  label: {
    cnName: 'Chinese Name',
    name: 'English Name',
    address: 'Address',
    email: 'Email Address',
    note: 'Note'
  },
  btn: {
    addInterviewMeetingRoom: 'Add'
  },
  message: {
    optionSuccess: 'Successfully saved.',
    optionField: 'Failed to save. Please try again.',
    deleteSuccess: 'Successfully deleted.',
    deleteInfo: 'Do you confirm you want to delete the {address} - {name} meeting room?'
  },
  placeholder: {
    cnName: 'Please input Chinese name',
    name: 'Please input English name',
    address: 'Please input address',
    email: 'Please input email address',
    note: 'Please input note',
    search: 'Keywords search'
  }
}
